// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"115":"@juggle/resize-observer","190":"snackbar","318":"react-autosuggest","907":"dialog"}[chunkId] + "." + {"115":"5a4f9ada","190":"2a90bc9f","318":"b74d637a","907":"a2aa2eb8"}[chunkId] + ".chunk.js";
};